import React, { Component } from "react";
import { Link } from "react-router-dom";
import confetti from "canvas-confetti";

import "./Shared.css";
import "./Trade.css";

import withRouter from "./functions/withRouter";
import { clearFavoriteBook } from "./functions/books";
import { createTrade, saveComment } from "./functions/trade";

import Authenticated from "./Authenticated";

class TradeCreate extends Component {
  constructor(props) {
    super(props);

    this.state = {comment: "", confetti: false};
  }

  createTrade = async (user) => {
    await createTrade(
      user,
      this.props.params.tradeID,
      this.props.params.givingBookID,
      this.props.params.receivingBookID,
      this.props.params.type,
      this.props.params.sessionID);
    clearFavoriteBook();
  }

  handleComment = (e) => {
    this.setState({comment: e.target.value});
  }

  updateComment = () => {
    saveComment(this.props.params.tradeID, this.state.comment);
  }

  render() {
    return (
      <Authenticated required={true} render={(user) => {
        this.createTrade(user);
        if (!this.state.confetti) {
          confetti().then(() => this.setState({confetti: true}));
        }

        return (
          <div className="Content">
            <div className="TradeMargin Column Center">
              <h1 className="HeaderText">Foreword</h1>
              <h2 className="TextCenter">Congratulations!</h2>
              <p>You just joined a community of wonderful people who are creating connection through literature.</p>
              {(this.props.params.type === "buy") ?
                <p>You should receive a confirmation email soon when your book ships! Happy reading!</p> :
                <p>Don't forget to mail your book and include the foreword! Once we receive your book, you will get an email confirmation. Your new book will be shipped to the address you provided during checkout. Happy reading!</p>
              }

              <h3>What makes this your favorite book? Tell your future reader why the book you're trading in is special to you</h3>

              <textarea onChange={this.handleComment} value={this.state.comment}></textarea>

              <Link to="/" className="Button Purple Margin TradeButton" onClick={this.updateComment} replace={true}>Save and Head Home</Link>
            </div>
          </div>
        );
      }}/>
    );
  }
}

export default withRouter(TradeCreate);
